import { createApp } from 'vue'
import { createHead, setHeadInjectionHandler } from '@unhead/vue'
import { createPinia } from 'pinia'
import { VueRecaptchaPlugin } from 'vue-recaptcha/head'
import './api'
import './assets/main.scss'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { VSnackbarQueue } from 'vuetify/labs/components'
import { da, en } from 'vuetify/locale'

import App from './App.vue'
import router from './router'

import * as Sentry from '@sentry/vue'

const vuetify = createVuetify({
  components: {
    ...components,
    VSnackbarQueue
  },
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi
    }
  },
  locale: {
    locale: 'da',
    fallback: 'en',
    messages: { da, en }
  },
  defaults: {
    VCard: {
      elevation: 0,
      color: 'primary'
    },
    VItemGroup: {
      VItem: {
        selectedClass: 'bg-primary'
      },
      VCard: {
        color: 'default'
      }
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
    },
    VAutocomplete: {
      variant: 'outlined',
      density: 'comfortable'
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable'
    }
  }
})

const app = createApp(App)
const head = createHead()

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration()
  ],
  enabled: import.meta.env.MODE !== 'development',
  ignoreTransactions: [
    /^GET \/healthz\/liveness$/,
    'healthz'
  ],
  tracesSampleRate: 0.2,
  tracePropagationTargets: ['localhost', /^https:\/\/sam-calc.com/],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  release: 'sam-calc-app@' + import.meta.env.PACKAGE_VERSION,
  environment: import.meta.env.VITE_SENTRY_ENV ?? 'Unknown'
})

app.use(VueRecaptchaPlugin, {
  v2SiteKey: import.meta.env.VITE_RECAPTCHA_V2_SITE_KEY ?? '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'
})

setHeadInjectionHandler(() => head)
app.use(createPinia())
app.use(router)
app.use(vuetify)

app.mount('#app')
